import { trackAssetClicked } from 'analytics/itly/hooks';
import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import Block from './Block';
import { HeroWrapper } from './HeroWrapper';

interface HomeHtmlBlockProps {
  id: string;
}

export const HomeHtmlBlock: React.FC<HomeHtmlBlockProps> = ({ id }) => {
  const heroWrapperRef = useRef<HTMLDivElement | null>(null);
  useApplyTrackAssetClickedToLinks(heroWrapperRef, id);
  const [isMounted, setIsMounted] = useState(true);

  useEffect(() => {
    return () => {
      setIsMounted(false);
    };
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <Block
      id={id}
      render={(content) => (
        <HeroWrapper blur={false} ref={heroWrapperRef} dangerouslySetInnerHTML={{ __html: content }} />
      )}
    />
  );
};


export const useApplyTrackAssetClickedToLinks = (ref: MutableRefObject<HTMLDivElement | null>, id: string): void => {
  useEffect(() => {
    const links = ref?.current?.getElementsByTagName('a');
    for (let i = 0; i < links?.length; i++) {
      const tag = links.item(i);
      const creative = tag.getAttribute('alt') || id;
      const location = id;
      const navigationTarget = tag.getAttribute('href');
      if (creative && location && navigationTarget) {
        tag.addEventListener('click', () => trackAssetClicked(creative, location, navigationTarget));
      }
    }
  // TODO: Refactor these dependencies
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
};
